module.exports = __webpack_public_path__ + "static/image/company/pc/image_better.jpg?c24c8fa0";